import { render, staticRenderFns } from "./BenchmarkTab.vue?vue&type=template&id=0b9de18c"
import script from "./BenchmarkTab.vue?vue&type=script&lang=js"
export * from "./BenchmarkTab.vue?vue&type=script&lang=js"
import style0 from "./BenchmarkTab.vue?vue&type=style&index=0&id=0b9de18c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports